import React from 'react'
import moment from 'moment/moment'
import { Link } from 'react-router-dom'
import convertDateOverTime from '../../../../helpers/convertDateOverTime'

function SewingRepairRow(props) {
    const { item, setType, setBrand } = props
    const { batch_id, sewing_repair, product_type } = item
    const { partner, sewing_partner } = { ...batch_id }
    const barcode_number = item.item.marketplace
    const item_number = item.item.item_number
    const brand = item.item.brand
    const barcodeNumber = barcode_number + '_' + item_number
    const overTime = item.item.overtime
    
    const onClickType = (value) => {
        setType(value)
    }
    const onClickBrand = (value) => {
        setBrand(value)
    }

    function _detectChecked() {
        const {item, selectedBatchId} = props

        return selectedBatchId.includes(item.item._id)
    }

    function _handleChange() {
        const {item, onUpdateSelectedBatches} = props
        const isChecked = _detectChecked()

        onUpdateSelectedBatches(item.item._id, !isChecked, item.item._id)
    }
    const overtimeText = !!overTime ? convertDateOverTime(overTime) : '-'

    return (
        <tr>
            <td className="BatchSelectedAll">
                <input
                    type="checkbox"
                    checked={_detectChecked()}
                    onChange={_handleChange}
                />
            </td>
            <td>
                {!!barcode_number &&
                    <Link
                        to={`/order-item?template=${barcodeNumber}`}
                        target='_blank'>
                        #{barcodeNumber}
                    </Link>
                }
            </td>
            <td className='ProductType'>
                {!!product_type &&
                    <span className="mr-2" onClick={() => onClickType([product_type])}>{product_type}</span>
                }
                {!!brand && !!brand.name &&
                    <div className='Brand'>
                        <span className="mr-2" onClick={() => onClickBrand([brand.name])}>{brand.name}</span>
                    </div>
                }
            </td>
            <td>{item.item.size || '-'}</td>
            <td>{moment(sewing_repair.pending_at).format('HH:mm DD/MM/YYYY') || '-'}</td>
            <td>{!!sewing_repair && !!sewing_repair.type ? sewing_repair.type : '-'}</td>
            <td className='OverTime d-flex align-items-center'>
                {overTime > 0 &&
                    <label
                        className='btn btn-sm mr-1 mb-0'
                        style={{
                            background: 'rgb(255 77 80)',
                            color: 'white',
                        }}
                    >
                        Quá hạn
                    </label>
                }
                <span className={`mb-0 ${overTime > 0 ? 'text-danger' : ''}`}>{overtimeText}</span>
            </td>
            <td>{!!partner && !!partner.name ? partner.name : '-'}</td>
            <td>{!!sewing_partner && !!sewing_partner.name ? sewing_partner.name : '-'}</td>
        </tr>
    )
}

export default SewingRepairRow